import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2IndividualIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 23 47",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 47),
    children: [/*#__PURE__*/jsx("circle", {
      cx: "11.5",
      cy: "7",
      r: "6"
    }), /*#__PURE__*/jsx("path", {
      d: "M22 26.5a10.5 10.5 0 10-21 0V31h4.5L7 46h9l1.5-15H22z"
    })]
  });
};

export { PM2IndividualIcon };
//# sourceMappingURL=individual.js.map
